import { lazy, Suspense } from "react";
import {
  Route,
  Switch,
  withRouter,
  Redirect
} from "react-router-dom";
import Loading from "../../components/Loading";

import './index.scss'

const OperateCenter = lazy(() => import("../../routers/OperateCenter"));
const FinanceCenter = lazy(() => import("../../routers/FinanceCenter"));
const UserCenter = lazy(() => import("../../routers/UserCenter"));
const TemporaryCenter = lazy(() => import("../../routers/TemporaryCenter"));
const GoodsDetail = lazy(() => import("../../views/GoodsDetail"));
const Home = lazy(() => import("../../views/Home"));

const BasicRouter = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path="/home" exact component={Home} />
        {/* 运营中台 */}
        <Route path="/operateCenter" component={OperateCenter} />

        {/* 会员中台 */}
        <Route path="/userCenter" component={UserCenter} />

        {/* 财务中台 */}
        <Route path="/financeCenter" component={FinanceCenter} />

        {/* 技术-临时频道 */}
        <Route path="/temporaryCenter" component={TemporaryCenter} />

        <Route path="/goods/detail" exact component={GoodsDetail} />

        <Redirect from="/" to="/operateCenter" />
      </Switch>
    </Suspense>

  )
};

export default withRouter(BasicRouter);
